const WEATHER_NAMES = {
  RAINING: 'Hujan',
  CLOUDY: 'Berawan',
  SUNNY: 'Cerah'
}

export function getName (type) {
  return WEATHER_NAMES[type]
}